import { IocSelectorOption } from './../ioc-selector/ioc-selector.service';
import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild, inject } from '@angular/core';
import { IonSelect } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddTemplateService } from './add-template.service';
import { IocSelectorService } from '../ioc-selector/ioc-selector.service';
import { TranslateService } from '@ngx-translate/core';

interface Template {
    type: string;
    subtype: string;
}

@Component({
  standalone: false,
    selector: 'app-add-template',
    templateUrl: './add-template.component.html',
    styleUrls: ['./add-template.component.scss'],
})


export class AddTemplateComponent implements OnDestroy {
    @ViewChild('selectTemplate') selectTemplate: IonSelect;
    @Input() type = 'item';
    @Output() selectedSubtype = new EventEmitter<Template>();
    private translateService = inject(TranslateService);
    templateName = this.translateService.instant('None');

    private readonly destroy$: Subject<void> = new Subject();
    private iocSelectorService = inject(IocSelectorService);
    private addTemplateService = inject(AddTemplateService);

    constructor( ) { }

    async ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async chooseType() {
        const title = this.translateService.instant('Event Type');
        const showCancelButton = true;
        const iocSelectorOptions: IocSelectorOption[] =  [
            {
                label: this.translateService.instant('College'),
                value: 'college'
            },
            {
                label: this.translateService.instant('High school'),
                value: 'high-school'
            },
            {
                label: this.translateService.instant('Pickleball'),
                value: 'pickleball'
            },
            {
                label: this.translateService.instant('Other'),
                value: 'other'
            }
        ]
        const type: string = await this.iocSelectorService.openPopover(title, iocSelectorOptions, showCancelButton);
        if (type) {
            this.chooseSubtype(type);
        }
    }

    chooseSubtype(type) {
        this.addTemplateService
            .index({ type })
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                async res => {
                    const templates = res.data;
                    const iocSelectorOptions: IocSelectorOption[] = [];

                    templates.forEach(t => {
                        iocSelectorOptions.push({
                            label: t.name,
                            value: t
                        });
                    });

                    const title = this.translateService.instant('Add Template');
                    const showCancelButton = true;

                    const selectedTemplate = await this.iocSelectorService.openPopover(title, iocSelectorOptions, showCancelButton);

                    if (selectedTemplate) {
                        this.templateName = selectedTemplate.name;
                        this.handleSubtypeChange(type, selectedTemplate.subtypes[0]);
                    }
                }
            );
    }

    private handleSubtypeChange(type, subtype) {
        this.selectedSubtype.emit({
            type,
            subtype
        });
    }
}
